/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "jcaportalweb",
            "endpoint": "https://1yot03n4mj.execute-api.us-east-1.amazonaws.com/rc",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:845951ef-8ce1-4f65-8627-f83385cd3dad",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_FKxCuZ7pP",
    "aws_user_pools_web_client_id": "4doshfkq3ctcqcmjvbml252fm",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "jcaportalweb-rc",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d28n99vefnpyog.cloudfront.net",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AuditTrails-rc",
            "region": "us-east-1"
        },
        {
            "tableName": "ConnectionEvents-rc",
            "region": "us-east-1"
        },
        {
            "tableName": "PublicKeys-rc",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
